import React from 'react';
import { Button } from './ui/Button';
export function Contact() {
  return <section id="contact" className="bg-swiss-red border-b-2 border-black" data-id="element-53">
      <div className="container mx-auto px-0" data-id="element-54">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-55">
          {/* Info */}
          <div className="p-8 lg:p-16 border-b-2 lg:border-b-0 lg:border-r-2 border-black bg-white" data-id="element-56">
            <h2 className="text-5xl md:text-7xl font-heading font-black text-black uppercase mb-8 leading-none" data-id="element-57">
              Let's
              <br data-id="element-58" />
              Work
              <br data-id="element-59" />
              Together
            </h2>
            <p className="text-xl font-medium text-black mb-12 max-w-md" data-id="element-60">
              Ready to start your next project? Contact us today for a free
              consultation.
            </p>

            <div className="space-y-8" data-id="element-61">
              <div data-id="element-62">
                <h4 className="font-bold uppercase tracking-wider text-sm text-gray-500 mb-2" data-id="element-63">
                  Visit Us
                </h4>
                <p className="text-xl font-bold" data-id="element-64">123 Design Street, NYC</p>
              </div>
              <div data-id="element-65">
                <h4 className="font-bold uppercase tracking-wider text-sm text-gray-500 mb-2" data-id="element-66">
                  Email Us
                </h4>
                <p className="text-xl font-bold underline decoration-2 underline-offset-4 decoration-swiss-red" data-id="element-67">
                  hello@pixelperfect.agency
                </p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="p-8 lg:p-16 bg-swiss-gray" data-id="element-68">
            <form className="space-y-6 max-w-lg mx-auto" data-id="element-69">
              <div className="space-y-2" data-id="element-70">
                <label htmlFor="name" className="text-sm font-black uppercase tracking-wider" data-id="element-71">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-4 bg-white border-2 border-black text-black font-bold focus:outline-none focus:ring-0 focus:border-swiss-red transition-colors" placeholder="YOUR NAME" data-id="element-72" />
              </div>
              <div className="space-y-2" data-id="element-73">
                <label htmlFor="email" className="text-sm font-black uppercase tracking-wider" data-id="element-74">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-4 bg-white border-2 border-black text-black font-bold focus:outline-none focus:ring-0 focus:border-swiss-red transition-colors" placeholder="YOUR EMAIL" data-id="element-75" />
              </div>
              <div className="space-y-2" data-id="element-76">
                <label htmlFor="message" className="text-sm font-black uppercase tracking-wider" data-id="element-77">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-4 bg-white border-2 border-black text-black font-bold focus:outline-none focus:ring-0 focus:border-swiss-red transition-colors resize-none" placeholder="TELL US ABOUT YOUR PROJECT..." data-id="element-78" />
              </div>

              <Button size="lg" className="w-full bg-black text-white hover:bg-swiss-red hover:border-swiss-red shadow-[4px_4px_0px_0px_rgba(0,0,0,0.2)]" data-id="element-79">
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}